import ProductStockListPanel from './productStockListPanel.container';

export default ProductStockListPanel